import React from "react";
import {LoadMenuItemDetailsEpic} from '../../actions/website.actions';
import {SaveMenuItemEpic} from '../../actions/website.actions';
import {DeleteMenuItemEpic} from '../../actions/website.actions';
import {connect} from 'react-redux'
import { withRouter, Switch, Route } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';
import ErrorBlock from '../../components/ErrorBlock';
import WebsiteContentField from '../../components/WebsiteContentField';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

export class MenuItemDetails extends React.Component {
  constructor(props){
    super(props);
    this.state = { menu_item: {}};
  }
  componentDidMount() {
    this.props.loadMenuItemDetails(this.props.websiteId, this.props.menuId, this.props.groupId, this.props.menuItemId);
  }

  componentWillReceiveProps(newProps){
    this.setState(newProps);
  }

  onFieldChange = (propertyName, value) => {
    let menu_item = {
      ...this.state.menu_item,
      [propertyName]: value
    };
    this.setState({menu_item});
  }

  onSave = () => {
    const saveData = {
      menu_item_name: this.state.menu_item.menu_item_name,
      menu_item_description: this.state.menu_item.menu_item_description,
      menu_item_price: this.state.menu_item.menu_item_price,
      special: this.state.menu_item.special,
      vegetarian: this.state.menu_item.vegetarian,
      vegan: this.state.menu_item.vegan,
      kosher: this.state.menu_item.kosher,
      halal: this.state.menu_item.halal,
      gluten_free: this.state.menu_item.gluten_free,
      ocean_wise: this.state.menu_item.ocean_wise
    };

    this.props.save(this.props.websiteId, this.props.menuId, this.props.groupId, this.props.menuItemId, saveData);
  }

  onDelete = () => {
    if (window.confirm('Are you sure you want to delete this menu item?')) {
      this.props.delete(this.props.websiteId, this.props.menuId, this.props.groupId, this.props.menuItemId);
    }
  }

  itemDetails() {
    return (
      <div>
        <div style={{display: 'flex', flexDirection:'row', alignContent:'center', alignItems:'center'}}>
          <div><h1>Item Details</h1></div>
          <div style={{flex:1}}>&nbsp;</div>
          <div>
            <FlatButton label={"Delete"} secondary onClick={()=>this.onDelete()}/>
            <RaisedButton onClick={this.onSave} label="Save" primary={true}/>
          </div>
        </div>
        <WebsiteContentField type="text" value={this.state.menu_item.menu_item_name} onChange={(value)=> this.onFieldChange('menu_item_name', value)} label="Name" />
        <WebsiteContentField type="text" value={this.state.menu_item.menu_item_description} onChange={(value)=> this.onFieldChange('menu_item_description', value)} label="Description" />
        <WebsiteContentField type="text" value={this.state.menu_item.menu_item_price} onChange={(value)=> this.onFieldChange('menu_item_price', value)} label="Price" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.special} onChange={(value)=> this.onFieldChange('special', value)} label="Special" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.vegetarian} onChange={(value)=> this.onFieldChange('vegetarian', value)} label="Vegetarian" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.vegan} onChange={(value)=> this.onFieldChange('vegan', value)} label="Vegan" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.kosher} onChange={(value)=> this.onFieldChange('kosher', value)} label="Kosher" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.halal} onChange={(value)=> this.onFieldChange('halal', value)} label="Halal" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.gluten_free} onChange={(value)=> this.onFieldChange('gluten_free', value)} label="Gluten Free" />
        <WebsiteContentField type="toggle" value={this.state.menu_item.ocean_wise} onChange={(value)=> this.onFieldChange('ocean_wise', value)} label="Ocean Wise" />
      </div>
      );
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }

    if (this.props.error) {
      return <ErrorBlock errorText="Unable to retrieve menu details at this time."/>
    }

    if (!this.props.menu_item){
      return <span></span>;
    }

    return (
     <div>
       <div>
         <div>
            <Switch> 
              <Route path='/websites/:websiteId/menu/:menuId/group/:groupId/item/:menuItemId/details' render={() => this.itemDetails()}/>
              <Route path='/websites/:websiteId/menu/:menuId/group/:groupId/item/:menuItemId' exact={true} render={() => this.itemDetails()}/>
            </Switch>
          </div>
         </div>
      </div>);
  }
}

let mapStateToProps = ({websiteEndpoint, referenceData},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError,
  menuId: match.params.menuId,
  websiteId: match.params.websiteId,
  groupId: match.params.groupId,
  menuItemId: match.params.menuItemId,
  menu_item: websiteEndpoint.menu_item
})

let mapDispatchToProps = (dispatch) => ({
  loadMenuItemDetails : (websiteId, menuId, groupId, menuItemId) => dispatch(LoadMenuItemDetailsEpic(websiteId, menuId, groupId, menuItemId)),
  save : (websiteId, menuId, groupId, menuItemId, data) => dispatch(SaveMenuItemEpic(websiteId, menuId, groupId, menuItemId, data)),
  delete : (websiteId, menuId, groupId, menuItemId) => dispatch(DeleteMenuItemEpic(websiteId, menuId, groupId, menuItemId))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MenuItemDetails));



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuItemDetails.js